<template>
  <div class="c-selectBox">
    <div
      class="c-selectBox__item"
      v-for="(item, key) in items"
      v-bind:class="{ 'c-selectBox__item--selected': selected(item) }"
      v-on:click="$emit('select', item)"
      :key="key"
    >
      <div class="c-selectBox__item__content">
        <slot :item="item"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selected: {
      default: () => () => {
        return false;
      },
    },
  },
};
</script>
<style lang="scss">
@import "../_variables.scss";
.c-selectBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  //   min-height: 45vh;
  margin-top: -0.5rem;
  max-width: 1350px;
  margin: 0 auto;
  &__item {
    $t: &;
    padding: 0.5rem;
    width: 100%;
    text-align: center;
    display: flex;
    cursor: pointer;
    @media (min-width: 1024px) {
      width: calc(100% / 5);
    }
    @media (max-width: 1024px) {
      width: calc(100% / 4);
    }
    @media (max-width: 960px) {
      width: calc(100% / 3);
    }
    @media (max-width: 780px) {
      width: 100%;
    }
    &:hover {
      #{$t}__content {
        &::after {
          content: " ";
          display: block;
          position: absolute;
          border: 5px solid $green;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          z-index: 1;
        }
        * {
          z-index: 2;
        }
      }
    }
    &--selected,
    &--selected:hover {
      #{$t}__content {
        position: relative;
        &::after {
          content: " ";
          display: block;
          position: absolute;
          border: 5px solid $green;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          z-index: 1;
        }
        * {
          z-index: 2;
        }
      }
    }

    &__content {
      display: flex;
      justify-content: center;
      align-items: center;
      background: $white;
      padding: 5%;
      width: 100%;
      &::before {
        transition: all 0.25s;
      }
    }
  }
  &__title {
    font-weight: 100;
    font-size: 1.25rem;
    display: block;
  }
  &__subtitle {
    font-weight: 100;
    font-size: 1.2rem;
    display: block;
    margin: 0.5rem 0 0 0;
    color: $green;
  }
  &__text {
    font-weight: 100;
    font-size: 0.75rem;
    display: block;
    margin: 0.5rem 0 0 0;
    color: $darkGray;
  }
}
</style>
